import React from "react";
import BannerCard from "@/components/ui/banner-card";
import KeyFacts from "@/components/pages/country/key-facts";
import Insights from "@/components/pages/country/insights";
import AdditonalResources from "@/components/pages/country/additonal-resources";
import {
  keyFacts,
  climateImpacts,
  stories,
  partners,
  seo,
  jsonLd,
  insights,
  learnMore,
} from "@/data/indonesia";
import ClimateImpacts from "@/components/pages/country/climate-impacts";
import Partners from "@/components/pages/country/partners";
import States from "@/components/pages/country/states";
import Section from "@/components/ui/section";
import Head from "next/head";
import Seo from "@/utils/seo";
import StoriesIndonesia from "@/components/pages/country/stories-indonesia";

export default function Indonesia() {
  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "Indonesia",
          image: "/images/indonesia/Indonesia Banner.webp",
        }}
        isActive={true}
        variant="single"
        description="PCI operates two initiatives in Indonesia: Migrants Resilience Collaborative and the Climate Resilience Initiative."
      />
      <KeyFacts data={keyFacts} />
      <ClimateImpacts data={climateImpacts} columns={2} />

      <StoriesIndonesia />
      <Partners data={partners} />
      <States
        map="/images/maps/image-Indonesia.webp"
        title="Geographical Presence of PCI"
        mapClass="lg:w-[800px] w-full lg:h-[400px] md:h-[400px] h-[200px]"
        className="mb-12"
      />
      <Section className="bg-[#F4F9FF] -mt-20">
        <h2 className="text-darkBlue text-center mb-12">
          About Internal Migration in Indonesia
        </h2>
        <Insights data={insights} />
      </Section>
      <AdditonalResources data={learnMore} />
    </>
  );
}
